import { Button, Card, Spinner } from 'react-bootstrap';
import { FaClock, FaHistory, FaPlus, FaSave } from 'react-icons/fa';

const BTN_STYLE = { minWidth: 90, fontSize: '0.78rem' };

export default function AgendaToolbar({
  isEditing,
  agendaContext,
  onGerarHorarios,
  onNovoEncaixe,
  onOpenHistory,
  onSaveAgenda,
  // onCloseForm,
  isSubmitting = false,
  isSaveDisabled = false,
  showForm = false,
}) {
  const hasSelectedContext = Boolean(agendaContext?.CODPAC || agendaContext?.CODAGENDA);

  return (
    <Card className="mb-2 shadow-sm border-0" style={{ borderLeft: '4px solid #1f6f3b' }}>
      <Card.Header
        className="d-flex justify-content-between align-items-center py-1 px-2"
        style={{ background: 'linear-gradient(90deg, #e9f6ec 0%, #f5fbf6 100%)' }}
      >
        <strong style={{ color: '#1f6f3b', fontSize: '0.85rem' }}>
          {showForm
            ? isEditing
              ? `Editando #${agendaContext?.CODAGENDA}`
              : 'Nova Agenda / Encaixe'
            : 'Controle de Agendamentos'}
        </strong>

        <div className="d-flex align-items-center gap-1">
          {/* Gerar Horários: Sempre disponível, mesmo sem horários na tela */}
          <Button
            variant="outline-success"
            size="sm"
            onClick={onGerarHorarios}
            disabled={isSubmitting}
            style={BTN_STYLE}
            title="Gera a grade de horários do médico para este dia"
          >
            <FaClock className="me-1" size={11} />
            Ag. Horários
          </Button>

          {/* Encaixe / Nova Agenda: Permite criar nova entrada */}
          <Button
            variant="outline-warning"
            size="sm"
            onClick={onNovoEncaixe}
            disabled={isSubmitting}
            style={BTN_STYLE}
            title="Inserir um novo horário ou encaixe"
          >
            <FaPlus className="me-1" size={11} />
            Nova Agenda
          </Button>

          {/* Histórico: Ativo quando há paciente/agenda selecionada */}
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onOpenHistory}
            disabled={isSubmitting || !hasSelectedContext}
            style={BTN_STYLE}
            title="Histórico de alterações do agendamento"
          >
            <FaHistory className="me-1" size={11} />
            Histórico
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onSaveAgenda}
            disabled={isSaveDisabled}
            style={BTN_STYLE}
            title="Salvar agendamento"
          >
            {isSubmitting ? (
              <Spinner animation="border" size="sm" className="me-1" />
            ) : (
              <FaSave className="me-1" size={11} />
            )}
            Salvar
          </Button>
        </div>
      </Card.Header>
    </Card>
  );
}
